<template>
  <div id="authority">
    <el-row>
      <h3>权限管理</h3>
    </el-row>

    <el-row>
      <!-- <el-row class="all">
          <div class="all-app"><el-checkbox label="全部应用" v-model="isAllApp"></el-checkbox></div>
          <div class="all-fun"><el-checkbox label="全部功能" v-model="isAllFun"></el-checkbox></div>
      </el-row> -->
      <el-table ref="authorityTable" :data="authoritiesTable" row-key="id" default-expand-all
                :tree-props="{ children: 'childrenList', hasChildren: 'hasChildren' }">
        <el-table-column show-overflow-tooltip min-width="1" label="应用列表">
          <template slot-scope="scope">
            <el-checkbox
              :style="scope.row.childrenList && scope.row.childrenList.length == 0 ? 'margin-left: 20px;' : ''"
              :label="scope.row.name" v-model="scope.row.checked"
              @change="setFun(scope.row)"></el-checkbox>

          </template>
        </el-table-column>
        <el-table-column min-width="3" label="功能列表">
          <template slot-scope="scope">

            <!-- <div v-if="scope.row.functionList && scope.row.functionList.length > 0">
                <el-checkbox
                    label="全选"
                    v-model="isAllFunOfApp[scope.$index]"
                    @change="set_all_fun_of_app(scope.row, isAllFunOfApp[scope.$index])"
                ></el-checkbox>
            </div> -->
            <!-- <span class="funcSpan"
                v-for="(power, index) in scope.row.functionList"
                :key="index">
                <el-checkbox
                    :label="power.alias"
                    v-model="power.checked"
                    @change="set_App(scope.$index, power.checked)"
                ></el-checkbox>
            </span> -->
            <!-- <div class="funcSpanBox">
            <div class="funcSpan"
                v-for="(power, index) in scope.row.functionList"
                :key="index">
                <el-tree
                    :data="[power]"
                    show-checkbox
                    node-key="id"
                    :ref="'functree'+ scope.row.id + power.id"
                    :props="defaultProps"
                    @check-change="checkChange"
                    >
                </el-tree>
            </div>
            </div> -->

            <!-- <el-checkbox-group v-model="scope.row.functionIds">
                <el-checkbox v-for="func in scope.row.functionList" :key="func.id" :label="func.id">
                    {{func.alias}}
                </el-checkbox>
            </el-checkbox-group> -->

            <el-tree :data="scope.row.buttonList" show-checkbox node-key="id"
                     :ref="'functree' + scope.row.id" :props="defaultProps" @check-change="checkChange">
            </el-tree>
          </template>
        </el-table-column>
      </el-table>
    </el-row>
  </div>
</template>
<script>
import {Loading} from "element-ui"

export default {
  props: {
    // 已勾选的菜单和操作
    appPermissions: {
      type: Array
    },

  },
  computed: {
    authoritiesTable() {
      if (this.appPermissions && this.appPermissions.length > 0) {
        this.initCheckeds();

        setTimeout(() => {
          const _this = this;
          this.authorities.forEach(app => {

            if (app.checked) {
              const refItem = _this.$refs['functree' + app.id];
              if (refItem) {
                refItem.setCheckedKeys(app.buttonIds)
              }

              if (app.childrenList && app.childrenList.length > 0) {
                app.childrenList.forEach(childApp => {
                  if (childApp.checked) {
                    const childrefItem = _this.$refs['functree' + childApp.id]
                    if (childrefItem) {
                      childrefItem.setCheckedKeys(childApp.buttonIds)
                    }
                  }
                })
              }

            }
          })
        }, 100)
      }

      return this.authorities
    },
    // 全部应用是否选中
    isAllApp: {
      get(state) {
        for (let app of state.authorities)
          if (app.checked === false)
            return false;
        return true;
      },
      set(checked) {
        this.set_all_app(checked)
      }
    },
    // 功能是否全部选中
    isAllFun: {
      get(state) {
        for (let app of state.authorities) {
          if (app.checked === false)
            return false;
          for (let fun of app.functionList)
            if (fun.checked === false)
              return false;
        }
        return true;
      },
      set(checked) {
        this.set_all_fun(checked)
      }
    },
    // 某个应用下的所有功能
    isAllFunOfApp: {
      get: state =>
        state.authorities.map((app) => {
          if (app.checked !== false) {
            for (let fun of app.functionList)
              if (fun.checked === false)
                return false;
            return true
          }
          return false
        })
    },

  },
  data: vm => ({
    authorities: [], //权限列表
    //树结构配置
    defaultProps: {
      children: 'buttonList',
      label: 'alias'
    },
  }),
  mounted() {
    this.getAuthorityList()
  },
  methods: {
    funcExist(func) {
      const funcChecked = this.appPermissions.some(
        apppermission => {
          return apppermission.functionPermissions.some(funcpermission => {
            return funcpermission.functionDto.id == func.id
          })
        }
      )
      return funcChecked
    },
    // 回显数据
    initCheckeds() {
      const _this = this;
      if (this.appPermissions.length == 0) {
        return
      }
      this.appPermissions.forEach(apppermission => {
        const appIndex = _this.authorities.findIndex(app => app.id == apppermission.id);

        if (appIndex != -1) {

          _this.authorities[appIndex].checked = true;

          // 子菜单
          if (apppermission.childrenList && apppermission.childrenList.length > 0) {
            apppermission.childrenList.forEach(childApppermission => {
              const childAppIndex = _this.authorities[appIndex].childrenList.findIndex(childApp => childApp.id == childApppermission.id)

              if (childAppIndex != -1) {
                _this.authorities[appIndex].childrenList[childAppIndex].checked = true;
                // if (childApppermission.childrenList && childApppermission.childrenList.length > 0) {
                //     childApppermission.childrenList.forEach(childApppermission_child => {
                //         const childAppIndex_child = _this.authorities[appIndex].childrenList[childAppIndex].childrenList.findIndex(childApp_child => childApp_child.id == childApppermission_child.id)

                //         if (childAppIndex_child != -1) {
                //             _this.authorities[appIndex].childrenList[childAppIndex].childrenList[childAppIndex_child].checked = true;

                //             let childFuncIds = [];
                //             childFuncIds = (_this.setBtnIds(childApppermission_child, _this.authorities[appIndex].childrenList[childAppIndex].buttonList[childAppIndex_child]))
                //             // _this.$refs['functree' + childApppermission.id].setCheckedKeys(childFuncIds)
                //             _this.authorities[appIndex].childrenList[childAppIndex].childrenList[childAppIndex_child].functionIds = childFuncIds
                //         }
                //     });
                // }

                let childBtnIds = [];
                childBtnIds = (_this.setBtnIds(childApppermission, _this.authorities[appIndex].childrenList[childAppIndex]))
                // _this.$refs['functree' + childApppermission.id].setCheckedKeys(childFuncIds)
                _this.authorities[appIndex].childrenList[childAppIndex].buttonIds = childBtnIds
              }
            });
          }


          // 当前菜单下的操作
          let btnIds = [];
          btnIds = _this.setBtnIds(apppermission, _this.authorities[appIndex]);
          _this.authorities[appIndex].buttonIds = btnIds
          // const refItem = _this.$refs['functree' + apppermission.id]
          // if(refItem){
          //     refItem.setCheckedKeys(funids)
          // }
        }
      })
    },
    getAuthorityList() {
      let loading = Loading.service({
        fullscreen: true,
        text: "数据加载中..."
      });
      this.$axios
        .get(this.baseUrl3 + "app/findAll")
        .then(({data: {msg, data, code}}) => {
          if (code == 20000) {
            let appItem = {};
            data.forEach(app => {
              this.resetCheckedAndIds(app, app.id, app.id);
            })
            this.authorities = data
            // if (this.appPermissions) {
            //     this.initCheckeds()
            // }
          } else {
            this.$message({showClose: true, message: msg, type: "error"});
            console.log(msg);
          }
          loading.close();
        })
        .catch(error => {
          loading.close();
          this.$message({
            showClose: true,
            message: "系统异常",
            type: "error"
          });
          console.log(error);
        });
    },
    resetCheckedAndIds(node, parentId = null, rootParentId = null) {
      node.checked = false;
      node.buttonIds = [];
      node.appIds = [];
      node.parentMenuId = parentId;
      node.rootParentMenuId = rootParentId;
      if (node.childrenList && node.childrenList.length > 0) {
        node.childrenList.forEach(child => {
          this.resetCheckedAndIds(child, node.id, node.rootParentMenuId);
        });
      }
      let flag = node.route == null
      if (node.buttonList && node.buttonList.length > 0) {
        node.buttonList.forEach(button => {
          if (flag) {
            this.resetCheckedAndIds(button, node.parentMenuId, node.rootParentMenuId);
          } else {
            this.resetCheckedAndIds(button, node.id, node.rootParentMenuId);
          }

        });
      }
    },
    // 点击全部应用时，选中/取消所有的应用
    set_all_app(checked) {
      this.authorities.forEach(app => {
        app.checked = checked
      })
    },
    set_all_fun(checked) {

      return
      this.authorities.forEach(app => {
        app.checked = checked
        app.functionList.forEach(fun => {
          fun.checked = checked
        })
      })
    },
    set_all_fun_of_app(row, checked) {
      row.checked = checked
      row.functionList.forEach(fun => {
        fun.checked = checked
      })
      // const checked = this.isAllFunOfApp[index]
      // this.authorities[index].checked = checked
      // this.authorities[index].functionList.forEach(fun => {
      //     fun.checked = checked
      // })
    },
    set_App(index, checked) {
      // console.log(index)
      return
      if (checked) {
        this.authorities[index].checked = checked
      } else {
        this.authorities[index].checked = this.authorities[index].functionList.some(fun => fun.checked)
      }
    },
    // 菜单勾选 ok
    setFun(row) {

      let menuIndex = -1
      if (row.parentMenuId) {
        menuIndex = this.authorities.findIndex(app => app.id == row.parentMenuId)
        if (row.checked) {
          this.authorities[menuIndex].checked = row.checked
        } else {
          this.authorities[menuIndex].checked = this.authorities[menuIndex].childrenList.some(childmenu => childmenu.checked)
        }
      } else {
        if (row.childrenList && row.childrenList.length > 0) {
          row.childrenList.forEach(c => {
            c.checked = row.checked
          })
        }
      }
    },
    // 获取当前所有选择的应用和功能
    getCheckedAll() {
      const _this = this;
      // 第二版
      let model = {
        appIds: [],
        buttonIds: []
      };

      this.authorities.forEach(menu => {
        if (menu.checked) {
          model.appIds.push(menu.id);
          if (menu.childrenList && menu.childrenList.length > 0) {
            menu.childrenList.forEach(childMenu => {
              if (childMenu.checked) {
                model.appIds.push(childMenu.id);

                // childMenu.childrenList.forEach(childMenu_child => {
                //     if (childMenu_child.checked) {
                //         model.appIds.push(childMenu_child.id);

                //         const childMenuFuncIds = _this.getFuncIds(childMenu_child);
                //         model.functionIds = model.functionIds.concat(childMenuFuncIds)
                //     }
                // });
                const childMenuBtnIds = _this.getBtnIds(childMenu);
                model.buttonIds = model.buttonIds.concat(childMenuBtnIds)
              }
            });
          }
          const menuFuncIds = _this.getBtnIds(menu);
          model.buttonIds = model.buttonIds.concat(menuFuncIds)
        }
      });
      this.$emit('getMenu', model)
    },
    // 菜单的操作
    getBtnIds(menu) {
      let ids = []
      const _this = this
      // if(!menu.functionList || menu.functionList.length == 0){
      //     return ids
      // }

      // menu.functionList.forEach(func => {
      //     let refName = 'functree' + menu.id
      //     let funIds = _this.$refs[refName][0].getCheckedKeys(true)
      //     ids = ids.concat(funIds)
      // })

      const refName = _this.$refs['functree' + menu.id]
      if (refName) {
        const btnIds = refName.getCheckedKeys()
        const halfIds = refName.getHalfCheckedKeys()
        ids = ids.concat(btnIds).concat(halfIds)
      }
      return ids
    },
    setBtnIds(menu, targetMenu) {
      let ids = []
      if (menu.buttonList && menu.buttonList.length > 0) {
        menu.buttonList.forEach(funcp => {
          const funcIndex = targetMenu.buttonList.findIndex(
            func => func.id == funcp.id
          )

          if (funcIndex != -1) {
            const funid = targetMenu.buttonList[funcIndex].id
            // ids.push(funid)
            if (funcp.buttonList && funcp.buttonList.length > 0) {
              funcp.buttonList.forEach(childFun => {
                const cfunIndex = targetMenu.buttonList[funcIndex].buttonList.findIndex(
                  func => func.id == childFun.id
                )
                if (cfunIndex != -1) {
                  ids.push(childFun.id)
                }
              })

            } else {
              ids.push(funid)
            }
          }
        })
      }

      return ids
    },
    /*
    * 节点选中状态发生变化时的回调
    * params: {
    *   传递给 data 属性的数组中该节点所对应的对象
    *   节点本身是否被选中
    *   节点的子树中是否有被选中的节点
    * }
    */
    checkChange(node, checked, hasChildChecked) {
      if (checked) {
        let pIndex = -1
        if (node.rootParentMenuId) {
          const rootIndex = this.authorities.findIndex(app => app.id == node.rootParentMenuId)
          this.authorities[rootIndex].checked = true
          if (this.authorities[rootIndex].childrenList && this.authorities[rootIndex].childrenList.length > 0) {
            pIndex = this.authorities[rootIndex].childrenList.findIndex(childApp => childApp.id == node.parentMenuId)
            if (pIndex != -1) {
              this.authorities[rootIndex].childrenList[pIndex].checked = true
            }

          }
        } else {
          pIndex = this.authorities.findIndex(app => app.id == node.parentMenuId)
          if (pIndex != -1) {
            this.authorities[pIndex].checked = true
          }

        }
      }
    },
  },
}
</script>
<style scoped>
.all div {
  display: inline-block;
}

.all-app {
  width: 25%;
}

.all-fun {
  width: 75%;
}

.funcSpan {
  display: inline-block;
  margin-right: 15px;
}

.funcSpan:first-child {
  margin-left: -24px;
}

.funcSpanBox {
  display: flex;
}

#authority >>> .el-tree__empty-text {
  display: none;
}
</style>
